import { render } from "./EuropaView.vue?vue&type=template&id=539bc576"
import script from "./EuropaView.vue?vue&type=script&lang=js"
export * from "./EuropaView.vue?vue&type=script&lang=js"

import "./EuropaView.vue?vue&type=style&index=0&id=539bc576&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__